__webpack_require__.p = "/atmkenya/";